export enum StockStatus {
    False = 'FALSE',
    Maybe = 'MAYBE',
    True = 'TRUE',
}

export interface StockCheckResponse {
    updateStockAvailability: UpdateStockAvailability[];
}

export interface UpdateStockAvailability {
    itemId: string;
    inStock: StockStatus;
    lastStockCheck: string;
    __typename: string;
}
